import React from "react";
import {
  Box,
  Typography,
  TextField,
  TextFieldProps,
  TypographyProps,
  styled,
  Paper,
  keyframes,
} from "@mui/material";
import { Dashboard as DashboardIcon } from "@mui/icons-material";
// Animation keyframes
const slideIn = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

// Styled components
const SmmTicketProfileCard = styled(Paper)(({ theme }) => ({
  animation: `${slideIn} 0.3s ease-out`,
  transition: "all 0.2s ease",
  "&:hover": {
    transform: "translateY(-2px)",
  },
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));

type SettingRow = {
  label: string;
  value: number;
  unit: string;
  key: string;
  type: string;
  inputProps?: TextFieldProps;
  typographyProps?: TypographyProps;
};

type ReusableSmmTicketProfileCardProps = {
  icon?: React.ReactNode;
  title: string;
  settings: SettingRow[];
};

const ReusableSmmTicketProfileCard = ({
  icon = <DashboardIcon />,
  title,
  settings,
}: ReusableSmmTicketProfileCardProps) => {


  return (
    <Box>
      <SmmTicketProfileCard elevation={3}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          {React.cloneElement(icon as React.ReactElement, { sx: { mr: 1 } })}
          <Typography variant="h6">{title}</Typography>
        </Box>

        {settings.map((setting) => (
          <Box key={setting.key} sx={{ mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2,justifyContent:"flex-start" }}>
              <Typography
                variant="body1"
                sx={{ minWidth: 200 }}
                {...setting.typographyProps}
              >
                {setting.label}
              </Typography>
              <Typography
                variant="body1"
                sx={{ minWidth: 200 }}
                {...setting.typographyProps}
              >
                {setting.value}
              </Typography>

              <Typography variant="body1">{setting.unit}</Typography>
            </Box>
          </Box>
        ))}
      </SmmTicketProfileCard>
    </Box>
  );
};

export default ReusableSmmTicketProfileCard;
